import BaseView from './BaseView';
import VacanciesHeader from '../../modules/VacanciesHeader';
import CarouselArticles from '../../modules/CarouselArticles';

let view = null;

class Vacancies extends BaseView {
    constructor(container) {
        super(container);
    }

    init() {

        const groups = new Map([
            [VacanciesHeader, this.container.querySelectorAll('[data-vacancies-header]')],
            [CarouselArticles, this.container.querySelectorAll('[data-carousel-articles]')],
        ]);

        super.createModules(groups);
    }
}

export default {
    namespace: 'template-vacancies',
    beforeEnter: ({ current, next, trigger }) => {
        view = new Vacancies(next.container);
        view.init();
    },
    afterLeave: ({ current, next, trigger }) => {
        view.destroy();
        view = null;
    },
};
